import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import { useCallback } from 'react';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';

import { updateReenterMember } from 'src/shared/services/memberService';
import { toast } from 'react-toastify';

type MemberReenterMemberModalProps = {
  modalOpen: boolean;
  onClose: () => void;
  memberId: number;
  onResignSuccess: (memberId: number) => void;
};

export const MemberReenterMemberModal = (props: MemberReenterMemberModalProps) => {
  const { modalOpen, onClose, memberId, onResignSuccess } = props;
  const isMounted = useIsMounted();

  const onCloseHandler = () => {
    // reset();
    onClose();
  };

  const onSubmit = useCallback(async () => {
    try {
      if (isMounted()) {
        await updateReenterMember(memberId);
        toast.success(t('member:reenter.saveSuccessMessage'));
        onResignSuccess(memberId);
      }
    } catch (error) {
      if (isMounted()) {
        ConsoleHelper.log('error', error);
      }
    }
  }, [isMounted, memberId, onResignSuccess]);

  return (
    <GenericDialog
      open={modalOpen}
      onClose={onCloseHandler}
      onSave={onSubmit}
      maxWidth='xs'
      showDialogActions
      padding={2}
      saveLabel={t('common:button.yes')}
      dialogContent={
        <Box display='flex' flexDirection='column' lineHeight={1.2}>
          <Typography variant='h6' fontWeight={(thm) => thm.typography.fontWeightBold} mb={1}>
            {t('member:reenter.wantToReenterMember')}
          </Typography>
        </Box>
      }
    />
  );
};
